import * as React from 'react';
import { AdminGuard } from './containers/AdminGuard';
import { AppStateProvider } from './contexts/AppState';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import { ErrorBoundary } from '@pec/aion-ui-core/components/ErrorBoundary';
import { FailureScreen } from './components/FailureScreen';
import { Form } from './components/Form';
import { SuccessScreen } from './components/SuccessScreen';
import { GtmWrapper } from '@pec/aion-ui-core/components/GtmWrapper';
import { Provider } from 'react-redux';
import { store } from 'store';

const theme = createMuiTheme({
  palette: {
    text: {
      primary: 'rgba(26, 28, 30, 1)'
    },
    primary: {
      main: '#005ca3'
    },
    error: {
      main: 'rgba(179, 38, 30, 1)'
    }
  },
  typography: {
    fontFamily: "'Open Sans', sans-serif",
    h4: {
      fontSize: '2rem',
      lineHeight: '2.5rem'
    },
    h6: {
      fontWeight: 600,
      fontSize: '0.875rem',
      lineHeight: '1.25rem',
      letterSpacing: '0.00625em',
      textAlign: 'start'
    },
    caption: {
      fontSize: '0.75rem',
      lineHeight: '1rem',
      letterSpacing: '0.025em'
    }
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 390,
      md: 960,
      lg: 1280,
      xl: 1920
    }
  },
  overrides: {
    MuiFormLabel: {
      root: {
        color: 'rgba(67, 71, 78, 1)'
      }
    },
    MuiFormControl: {
      root: {
        borderColor: 'rgba(115, 119, 127, 1)'
      }
    }
  }
});

export const App: React.FC = () => {
  return (
    <ErrorBoundary>
      <Provider store={store}>
        <AppStateProvider>
          <GtmWrapper>
            <MuiThemeProvider theme={theme}>
              <Router basename="/signup">
                <AdminGuard>
                  <Switch>
                    <Route path="/success" component={SuccessScreen} />
                    <Route path="/failure" component={FailureScreen} />
                    <Route path="/" exact component={Form} />
                  </Switch>
                </AdminGuard>
              </Router>
            </MuiThemeProvider>
          </GtmWrapper>
        </AppStateProvider>
      </Provider>
    </ErrorBoundary>
  );
};
